<script>
import RecoverAccountForm from '@/components/recoverPassword/RecoverAccountForm.vue';

export default {
  data() {
    return {
      imgYautyPath: "../public/assets/login/login_logo.png",
      imgLogginPath: '../public/assets/login/login.png',
    };
  },
  components: {
    RecoverAccountForm
  },
};
</script>

<template>
    <RecoverAccountForm />
</template>

<style lang="scss" scoped>
.recover-password__container{
  background-color: white;
}
</style>
